import { Switch, Route, Router as WouterRouter } from 'wouter';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { TooltipProvider } from '@/components/ui/tooltip';
import { AppLayout } from '@/components/layout';
import { ProfileProvider } from '@/lib/profile';
import Landing from '@/pages/landing';
import Pricing from '@/pages/pricing';
import Dashboard from '@/pages/dashboard';
import RoiCalculator from '@/pages/calculator';
import RoiCalculatorAdvanced from '@/pages/calculator-advanced';
import Reports from '@/pages/reports';
import NotFound from '@/pages/not-found';

const queryClient = new QueryClient();

function Router() {
    return (
        <Switch>
            <Route path="/" component={Landing} />
            <Route path="/pricing" component={Pricing} />
            <Route>
                <AppLayout>
                    <Switch>
                        <Route path="/dashboard" component={Dashboard} />
                        <Route path="/calculator/advanced" component={RoiCalculatorAdvanced} />
                        <Route path="/calculator" component={RoiCalculator} />
                        <Route path="/reports" component={Reports} />
                        <Route component={NotFound} />
                    </Switch>
                </AppLayout>
            </Route>
        </Switch>
    );
}

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <TooltipProvider>
                <ProfileProvider>
                    <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, '')}>
                        <Router />
                    </WouterRouter>
                    <Toaster />
                </ProfileProvider>
            </TooltipProvider>
        </QueryClientProvider>
    );
}

export default App;
